import React from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "@mui/material";

import StickyHeader from "@/components/StickyHeader";
import CertificateExportTable from "@/pages/awareness/progress/certificate_export/CertificateExportTable";

const CertificateExport = () => {
  const { t } = useTranslation();
  return (
    <>
      <StickyHeader>
        <Typography variant={"h2"}>{t("Certificate export")}</Typography>
      </StickyHeader>
      <CertificateExportTable />
    </>
  );
};

export default CertificateExport;
